import React, { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { CanvasImageUpload } from '../CanvasImageUpload/CanvasImageUpload';

interface CanvasImageProps {
  className?: string;
  onClick?: () => void;
  type?: 'default' | 'selected' | 'active';
  image?: string;
}

export const CanvasImage: React.FC<CanvasImageProps> = ({
  className = '',
  onClick,
  type = 'default',
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [showText, setShowText] = useState(true);
  const [iconSizePercent, setIconSizePercent] = useState(38.5);

  const getIconSizePercent = (width: number) => {
    if (width < 158) return 90;
    if (width < 175) return 75;
    if (width < 257) return 50;
    return 38.5;
  };

  useEffect(() => {
    if (!containerRef.current) return;

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const width = entry.contentRect.width;

        setShowText(width >= 257);
        setIconSizePercent(getIconSizePercent(width));
      }
    });

    resizeObserver.observe(containerRef.current);

    return () => resizeObserver.disconnect();
  }, []);

  const handleClick = () => {
    if (onClick) onClick();
  };

  return (
    <div
      ref={containerRef}
      className={clsx(
        'group relative inline-flex h-full max-h-full w-full max-w-full flex-col items-center justify-center bg-[#E7F8F0] transition-all',
        className,
      )}
    >
      <div className="flex flex-1 flex-col items-center justify-center gap-2.5 self-stretch overflow-hidden p-4">
        <CanvasImageUpload
          onClick={handleClick}
          className="h-full w-full cursor-pointer"
          type={type}
          text={
            showText ? (
              <>
                Click to Choose or <br /> Upload an image
              </>
            ) : null
          }
          aspect={showText ? '4/3' : 'square'}
          iconSizePercent={iconSizePercent}
        />
      </div>
    </div>
  );
};
